import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import React, { Fragment, useEffect, useState } from 'react';
import { Button } from '@sas/nova-commons/components/Button';
import { Flow } from '@sas/nova-commons/components/Layouts/Flow';
import { Popover } from '@sas/nova-commons/components/Popover';
import { Text } from '@sas/nova-commons/components/Text';
import { withLabels } from '@sas/nova-commons/components/withLabels';
import { BusyStateIndicator } from '@sas/nova-commons/components/BusyStateIndicator';
import { useI18n } from '../../../../locale/I18nContext';
import { AutoFocusInside } from 'react-focus-lock';
import { Link } from '@sas/nova-commons/components/Link';
import { HelpPopup } from '@sas/nova-commons/components/HelpPopup';
import { useBusyStateAnimationTokens } from '../../../utils/busyStateIndicatorTokens';
import cn from './LocationPopover.css.json';
import './LocationPopover.css';
const TextWithLabels = withLabels(Text);
const POPOVER_WIDTH = 400;
export const LocationPopover = (props) => {
    var _a, _b, _c, _d;
    const [visualizationRect, setVisualizationRect] = useState(null);
    const isOpen = !!props.locationCandidate;
    const dt = useDesignTokens();
    useEffect(() => {
        var _a;
        let objectRect;
        if (isOpen && props.contentId) {
            objectRect = (_a = document.getElementById(props.contentId)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        }
        setVisualizationRect(objectRect !== null && objectRect !== void 0 ? objectRect : null);
    }, [isOpen, props.contentId]);
    const localize = useI18n();
    const isBusy = props.locationCandidate && !props.locationCandidate.name && !props.locationCandidate.location;
    const location = (_b = (_a = props.locationCandidate) === null || _a === void 0 ? void 0 : _a.pixelLocation) !== null && _b !== void 0 ? _b : [0, 0];
    const tokens = renderInlineCssVars({
        'with-labels-spacing-xs': -1,
        'hint-font-size': dt.reportTokens.font.size.s,
        'hint-color': dt.reportTokens.text.description.fg,
        // take 1rem padding and 1px border into account for max footer width
        'footer-max-width': `${POPOVER_WIDTH - 34}px`,
    });
    const [disableLock, setDisableLock] = useState(false);
    useEffect(() => {
        setDisableLock(false);
    }, [props.locationCandidate]);
    const busyAnimationTokens = useBusyStateAnimationTokens();
    return (React.createElement(Popover
    // VASDK-2243: Disable exit animation. A bug in framer-motion causes the
    // Popover to remain mounted after the exit animation.
    , Object.assign({ 
        // VASDK-2243: Disable exit animation. A bug in framer-motion causes the
        // Popover to remain mounted after the exit animation.
        animation: { exit: undefined }, focusLockProps: {
            className: cn.resetCursor,
            disabled: disableLock,
            returnFocus: false,
        }, onEscape: props.onCancel, onOutsideClick: () => {
            setDisableLock(true);
            props.onOutsideClick();
        }, isModal: false, title: props.title, isOpen: !!props.locationCandidate, position: visualizationRect
            ? {
                left: visualizationRect.x + location[0],
                right: visualizationRect.x + location[0],
                width: 0,
                top: visualizationRect.y + visualizationRect.height - location[1],
                bottom: visualizationRect.y + visualizationRect.height - location[1],
                height: 0,
            }
            : undefined, style: { maxWidth: `${POPOVER_WIDTH}px` } }, (!isBusy && {
        footer: (React.createElement(Flow, { spacing: "xxs", className: cn.footer, style: tokens },
            React.createElement(Link, { onPress: props.onCancel, wrapText: false }, localize({ key: 'LocationPopover.cancel.txt' })),
            React.createElement(HelpPopup, { library: "vaeua-gui-eua", contentKey: "react.va.geo.search.exitSelectionMode" }),
            React.createElement(AutoFocusInside, null,
                React.createElement(Button, { onPress: props.onConfirm, text: localize({ key: 'LocationPopover.ok.txt' }) })))),
    })), isBusy ? (React.createElement(BusyStateIndicator, { animationTokens: busyAnimationTokens, active: true, delay: 0 })) : (React.createElement("div", { className: cn.content },
        ((_c = props.locationCandidate) === null || _c === void 0 ? void 0 : _c.name) ? (React.createElement(TextWithLabels, { label: localize({ key: 'LocationPopover.name.txt' }), labelPosition: "left", wrapText: false }, props.locationCandidate.name)) : null,
        ((_d = props.locationCandidate) === null || _d === void 0 ? void 0 : _d.location) ? (React.createElement(Fragment, null,
            React.createElement(TextWithLabels, { label: localize({ key: 'LocationPopover.location.txt' }), labelPosition: "left", wrapText: true, style: tokens }, props.locationCandidate.location),
            React.createElement(Text, { wrapText: false, className: cn.hint, style: tokens }, localize({ key: 'LocationPopover.hint.txt' })))) : null))));
};
